import { type ValueOf } from 'type-fest';
import { RouteAccess } from './utils/route-access';

export const AppRoute = {
  '/': '/',
  '/404': '/404',
  '/chat': '/chat',
  '/login': '/login',
  '/login/callback': '/login/callback',
  '/logout': '/logout',
} as const;

export type AppRoute = ValueOf<typeof AppRoute>;

export const AccessList: Record<AppRoute, RouteAccess[]> = {
  '/': [RouteAccess.LOGGED_IN_USER],
  '/404': [RouteAccess.EVERYONE],
  '/chat': [RouteAccess.LOGGED_IN_USER],
  '/login': [RouteAccess.GUEST],
  '/login/callback': [RouteAccess.GUEST],
  '/logout': [RouteAccess.LOGGED_IN_USER],
};
